import { bucketIndex, USAGE_BUCKETS, usageSeconds } from "./usageStatistics";
import { statusHours } from "./deviceStatus";
import districts from "@/assets/busanDistricts.json";

export const BUSAN_REGIONS = districts.map((district) => district.name);

export function deviceRegion(device) {
  const value = String(device?.school_region || "").trim();
  return (
    BUSAN_REGIONS.find((name) =>
      new RegExp(`(?:^|\\s|부산광역시|부산)${name}(?:$|\\s)`).test(value)
    ) || ""
  );
}

// Call after applying administrator scope and long-inactive visibility rules.
export function filterDashboardDevices(devices, query, region) {
  const keyword = String(query || "")
    .trim()
    .toLocaleLowerCase("ko");
  return devices.filter(
    (device) =>
      (!region || deviceRegion(device) === region) &&
      (!keyword ||
        [device.school_name, device.school_region, device.app_location].some(
          (value) =>
            String(value || "")
              .toLocaleLowerCase("ko")
              .includes(keyword)
        ))
  );
}

export function overuseDevices(devices) {
  return devices.filter(
    (device) =>
      String(device.status || "").toUpperCase() === "ACTIVE" &&
      statusHours(device) !== null &&
      statusHours(device) >= 24
  );
}

export function dashboardDistribution(devices) {
  const counts = USAGE_BUCKETS.map(() => 0);
  let unknown = 0;
  devices.forEach((device) => {
    const index = bucketIndex(usageSeconds(device.total_usage_sec));
    if (index < 0) unknown++;
    else counts[index]++;
  });
  return { counts, unknown };
}

export function dashboardRegionCounts(devices) {
  const counts = Object.fromEntries(BUSAN_REGIONS.map((region) => [region, 0]));
  devices.forEach((device) => {
    const region = deviceRegion(device);
    if (region) counts[region]++;
  });
  return counts;
}
